import colors from "src/utils/colors";
import { hexRegex } from "src/utils/constants";
import tw from "src/utils/tw";

interface Props {
  color?: string;
  className?: string;
}

export function ColorBlock(props: Props) {
  const validColor =
    props.color && props.color.replace("#", "").match(hexRegex);

  return (
    <div
      className={tw(
        "h-11 w-full rounded border",
        validColor ? "border-transparent" : "border-borderGray"
      )}
      css={{
        backgroundColor: validColor ? props.color : colors.bgGray,
      }}
    />
  );
}
